import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import HappyCustomerServices from '../services/HappyCustomerServices';
import useAsync from '../hooks/useAsync';
import TogalButtonForStatus from './TogelButton/TogalButtonForStatus';
import Modal from 'react-modal';
import DeleteButton from './Button/DeleteButton';
import HappyCustomerUpdate from './Update Model/UpdateHappyCustomer';
import * as XLSX from 'xlsx';

Modal.setAppElement('#root');

function HappyCustomer() {
    const { data, error, isLoading, run } = useAsync(HappyCustomerServices.getHappy);
    const [activeIndex, setActiveIndex] = useState(null);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [selectedEdit, setSelectedEdit] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');

    const handleEditDetails = (slider) => {
        setSelectedEdit(slider);
        setIsEditModalOpen(true);
        toggleActionMenu(null);
    };

    const handleDelete = (slider) => {
        setSelectedEdit(slider);
        setIsDeleteModalOpen(true);
        toggleActionMenu(null);
    };

    const closeEditModal = () => {
        setIsEditModalOpen(false);
        setSelectedEdit(null);
    };

    const closeDeleteModal = () => {
        setIsDeleteModalOpen(false);
        setSelectedEdit(null);
    };

    const toggleActionMenu = (index) => {
        setActiveIndex(index === activeIndex ? null : index);
    };

    const formatDateTime = (isoString) => {
        const date = new Date(isoString);
        const day = String(date.getDate()).padStart(2, '0'); // Get day and pad with leading zero if needed
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (0-11) and pad with leading zero
        const year = date.getFullYear(); // Get full year
        return `${day}-${month}-${year}`; // Format as DD-MM-YYYY
    };


    // Filtered data based on search query
    const filteredData = data?.data?.filter(happy =>
        happy.name.toLowerCase().includes(searchQuery.toLowerCase().trim())
    );

    function truncateText(text, limit) {
        const words = text.split(' ');
        if (words.length > limit) {
            return words.slice(0, limit).join(' ') + '...';
        }
        return text;
    }

    return (
        <>
            <div className="right_col" role="main">
                <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

                    <div className="my-auto">

                        <h5 className="page-title fs-21 mb-1">
                            Happy Customer List <span className="badge bg-orange">{filteredData?.length || 0}</span>                            </h5>
                        <nav>

                            <ol className="breadcrumb mb-0">

                                <li className="breadcrumb-item">
                                    <a href="javascript:void(0);">Home</a>
                                </li>
                                <li className="breadcrumb-item active" aria-current="page">
                                    Happy Customer
                                </li>
                            </ol>
                        </nav>
                    </div>
                    <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
                        <Link className="round-add-btn" to="/add-happy-customer">
                            <img src="img/plus.svg" alt="Add happy" />
                        </Link>



                    </div>
                </div>


                <div className="container-box px-0 pt-2">
                    <div className="Tablesearch_design">
                        <div className="row">
                            <div className='col-md-6'>
                                <div className='d-flex align-items-center justify-content-between gap-2'>
                                    <input
                                        type="search"
                                        name="search"
                                        placeholder="Search By Name"
                                        value={searchQuery}
                                        className='form-control'
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                    <button className="search-btn">Search</button>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="container-box-inner table-reponsive-tabe">
                        <table id="example" className="table table-striped" style={{ width: "100%" }}>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>NAME</th>
                                    <th>Image</th>
                                    <th>DESCRITPION</th>
                                    <th>RATING</th>
                                    <th>DATE</th>
                                    <th>STATUS</th>
                                    <th>ACTION</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData?.map((happy, i) => (
                                    <tr key={i}>
                                        <td>{i + 1}</td>
                                        <td>{happy?.name}</td>
                                        <td>
                                            <div className="product-img">
                                                <td>
                                                    <div className="product-img">
                                                        <img
                                                            src={process.env.REACT_APP_URL + happy?.video}
                                                            alt=""
                                                            style={{ height: '70px', width: '70px', objectFit: 'contain' }}
                                                        />
                                                    </div>
                                                </td>

                                            </div>
                                        </td>
                                        <td>{truncateText(happy?.description, 20)}</td>
                                        <td>{happy?.rating}</td>
                                        <td>{formatDateTime(happy?.createdAt)}</td>
                                        <td className="status-toggle">
                                            <TogalButtonForStatus data={happy} page="happy" onSuccess={() => run()} />
                                        </td>
                                        <td>
                                            <div className="action_toggle_outer">
                                                <button className="action_toggle" onClick={() => toggleActionMenu(i)}>
                                                    <i className="fa fa-ellipsis-v" />
                                                </button>
                                                {activeIndex === i && (
                                                    <div className="action_toggle_content product-edit show d-block">
                                                        <ul className="list-unstyled">
                                                            <li>
                                                                <button className="close_toggle" onClick={() => toggleActionMenu(null)}>
                                                                    <i className="fa fa-close" />
                                                                </button>
                                                            </li>
                                                            <li>
                                                                <button className="edit" onClick={() => handleEditDetails(happy)}>Edit</button>
                                                            </li>
                                                            <li>
                                                                <button className="reject" onClick={() => handleDelete(happy)}>Delete</button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <Modal
                    isOpen={isEditModalOpen}
                    onRequestClose={closeEditModal}
                    contentLabel="User Details"
                    className="modal-content"
                    overlayClassName="modal-overlay"
                >
                    <HappyCustomerUpdate happy={selectedEdit} closeModal={closeEditModal} onSuccess={run} />
                </Modal>
                <Modal
                    isOpen={isDeleteModalOpen}
                    onRequestClose={closeDeleteModal}
                    contentLabel="Delete Confirmation"
                    className="modal-content"
                    overlayClassName="modal-overlay"
                >
                    <DeleteButton data={selectedEdit} page="happy" closeModal={closeDeleteModal} onSuccess={run} />
                </Modal>
            </div>
        </>
    );
}

export default HappyCustomer;
